import Vue from 'vue';

export default Vue.component('section-wavetwo-divider', {
  template: require('./template.html'),
  name: 'section-wavetwo-divider',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/wave-two/index.js